import { render, staticRenderFns } from "./complex-menu-list-edit-modal.vue?vue&type=template&id=0093137a&"
import script from "./complex-menu-list-edit-modal.vue?vue&type=script&lang=ts&"
export * from "./complex-menu-list-edit-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports